import type { Response } from '~/types/api/v2'
import type { DocumentsMetaTag } from '~/types'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const responseDataTypeName: DocumentsMetaTag['_data_type'] = 'document.tag_data'

export const useFetchDocumentTags = () => {
  const { get } = useFetchWithDefaults()

  const getAll = ({ workspaceId }: WorkspaceIdentifier) =>
    get<Response<DocumentsMetaTag[]>>({
      url: '/v2/metadata/tags',
      workspaceId,
    })

  return {
    getAll,
  }
}
